import * as React from "react";
import { useCallback, useEffect, useState, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Header } from "../../components/Header";
import { SearchInputView } from "../../components/views/search/SearchInputView";
import "./searchScreenStyles.css";
import { SearchKeyboardView } from "../../components/views/search/SearchKeyboardView";
import { searchMovies } from "../../services/movie.service";
import { chunkArray, onMoviePress } from "../../utils/Helpers";
import { useRouter } from "../../context/Router";
import "../../styles/general.css";
import { MovieRowView } from "../../components/views/movie/MovieRowView";
import { focusManager } from "../../utils/Focus";
import { useTVScroll } from "../../hooks/useTVScroll";
import { ScrollToTopButton } from "../../components/views/buttons/ScrollToTopButton";
import { FooterView } from "../../components/views/footer/FooterView";
import { SkeletonContentLayout } from "../../components/views/SkeletonContentLayout";
import { useModalContext } from "../../context/ModalContext";
export var SearchScreen = function () {
    var navigate = useRouter().navigate;
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    var verticalRef = useRef(null);
    var _b = useState(""), phrase = _b[0], setPhrase = _b[1];
    var _c = useState([]), movies = _c[0], setMovies = _c[1];
    var _d = useState("ka"), keyboardLang = _d[0], setKeyboardLang = _d[1];
    var _e = useState(false), isLoading = _e[0], setIsLoading = _e[1];
    var _f = useState(10), loadedRowsCount = _f[0], setLoadedRowsCount = _f[1];
    var showModal = useModalContext().showModal;
    var scrollToTopVisible = useTVScroll({
        onEndReached: function () {
            if (loadedRowsCount < rows.length) {
                setLoadedRowsCount(function (prev) { return prev + 5; });
            }
        },
    }).scrollToTopVisible;
    var englishKeyboard = {
        firstRow: ["1", "2", "3", "0", "a", "b", "c", "d", "e", "f", "g", "h", "⌫"],
        secondRow: [
            "4",
            "5",
            "6",
            "i",
            "j",
            "k",
            "l",
            "m",
            "n",
            "o",
            "p",
            "q",
            "r",
            "s",
        ],
        thirdRow: ["7", "8", "9", "t", "u", "v", "w", "x", "y", "z", " ", "🌐"],
    };
    var rows = useMemo(function () { return chunkArray(movies, 6); }, [movies]);
    var georgianKeyboard = {
        firstRow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "⌫"],
        secondRow: ["ა", "ბ", "გ", "დ", "ე", "ვ", "ზ", "თ", "ი", "კ", "ლ", "მ"],
        thirdRow: ["ნ", "ო", "პ", "ჟ", "რ", "ს", "ტ", "უ", "ფ", "ქ", "ღ", "ყ"],
        fourthRow: ["შ", "ჩ", "ც", "ძ", "წ", "ჭ", "ხ", "ჯ", "ჰ", " ", "🌐"],
    };
    var keyboard = keyboardLang === "en" ? englishKeyboard : georgianKeyboard;
    var onKeyPress = useCallback(function (key) {
        if (key === "🌐") {
            return setKeyboardLang(function (prev) {
                var newLang = prev === "en" ? "ka" : "en";
                focusManager.updateGroupOrder();
                focusManager.registerGroup({ name: "main-navbar", position: 1 });
                focusManager.manualFocus("key-" + newLang + "-" + (newLang === "en" ? 2 : 3), newLang === "en" ? 11 : 10, true);
                return newLang;
            });
        }
        if (key === "⌫") {
            return setPhrase(function (prevState) { return prevState.slice(0, -1); });
        }
        setPhrase(function (prevState) { return prevState + key; });
    }, [phrase]);
    var handleSearch = useCallback(function (q, lang) {
        setIsLoading(true);
        return searchMovies({ q: q, lang: lang }).then(function (res) {
            setMovies(res.items);
            setIsLoading(false);
        });
    }, []);
    useEffect(function () {
        if (phrase.length > 0) {
            handleSearch(phrase, i18n.language);
        }
        else {
            setMovies([]);
        }
    }, [i18n.language, phrase, handleSearch]);
    useEffect(function () {
        focusManager.manualFocus("main-navbar", 3);
    }, [focusManager]);
    var handleMoviePress = useCallback(function (movie) {
        var result = onMoviePress(movie);
        if (result.type === "modal") {
            showModal(result.modalType);
            return;
        }
        navigate("watch", { slug: result.slug });
    }, [navigate, showModal]);
    useEffect(function () {
        rows.slice(0, loadedRowsCount).forEach(function (_, index) {
            focusManager.registerGroup({
                name: "row-" + index,
                position: index + 100,
                itemHeight: 530,
                verticalContainer: verticalRef.current,
            });
        });
    }, [rows, loadedRowsCount]);
    var renderedRows = useMemo(function () {
        return rows
            .slice(0, loadedRowsCount)
            .map(function (row, index) { return (React.createElement(MovieRowView, { key: index, index: index, hasHorizontalScroll: false, movies: row, onMoviePress: handleMoviePress })); });
    }, [rows, loadedRowsCount, handleMoviePress]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null),
        React.createElement("div", { ref: verticalRef, className: "screen-container" },
            React.createElement(SearchInputView, { phrase: phrase, setPhrase: setPhrase, verticalContainer: verticalRef.current }),
            React.createElement(SearchKeyboardView, { keyboard: keyboard, onKeyPress: onKeyPress, keyboardLang: keyboardLang, verticalContainer: verticalRef.current }),
            React.createElement("div", { key: movies.length, className: "search-movies-container" }, isLoading && movies.length === 0 ? (React.createElement(SkeletonContentLayout, { showTitle: false, skeletonCount: 6 })) : (renderedRows)),
            !isLoading && React.createElement(FooterView, null),
            scrollToTopVisible && React.createElement(ScrollToTopButton, null))));
};



//////////////////
// WEBPACK FOOTER
// ./src/screens/SearchScreen/SearchScreen.tsx
// module id = 163
// module chunks = 1